export enum CompanyName {
  Natura = 'natura',
  Avon = 'avon',
}
